export default "__VITE_ASSET__C4oMmsuI__"